import { getUserLocalePreference } from '@concerns/i18n/browser'

export interface SusiLightElement
  extends HTMLElement,
    Partial<SusiLightConfig> {
  type: SusiLightConfig['variant']
}

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'susi-sentry-light': SusiLightElement
    }
  }
}

export interface SusiLightConfig {
  variant: 'standard'
  popup: boolean
  stage: boolean
  config: {
    consentProfile:
      | 'adobe-id-sign-up'
      | 'purchase'
      | 'quote_request'
      | 'trial'
      | 'free'
  }
  authParams: {
    client_id: string
    dt: boolean
    locale: 'en-us' | string
    redirect_uri: string
    response_type: 'token' | string
    scope: string
  }
}

export const createSusiLightConfig = (
  redirectUri?: string
): SusiLightConfig => ({
  variant: 'standard',
  popup: true,
  stage: process.env.NEXT_PUBLIC_ADOBE_IMS_ENV !== 'prd',
  config: {
    consentProfile: 'adobe-id-sign-up'
  },
  authParams: {
    client_id: process.env.NEXT_PUBLIC_ADOBE_IMS_CLIENT_ID!,
    dt: false,
    locale: getUserLocalePreference()?.toLowerCase() || 'en-us',
    redirect_uri:
      redirectUri || (process.env.NEXT_PUBLIC_CLIENT_WEB_HOST as string),
    response_type: 'token',
    scope:
      'AdobeID,openid,pps.read,pps.search,firefly_api,account_cluster.read,read_organizations,tk_platform,tk_platform_sync'
  }
})

type IMSToken = string
export interface SusiLoadEvent {
  detail: { ready: boolean }
}
export interface SusiTokenEvent {
  detail: IMSToken
}
export interface SusiRedirectEvent {
  detail: URL | string
}
export interface SusiErrorEvent {
  detail: { error: { message: string; stack: string } }
}

export interface SusiLightWrapperProps {
  redirectUri?: string
  onSusiToken: (e: Event & SusiTokenEvent) => Promise<void> | void
  onSusiError: (e: Event & SusiErrorEvent) => void
  onSusiLoad?: (e: Event & SusiLoadEvent) => void
  onSusiRedirect?: (e: Event & SusiRedirectEvent) => Promise<void> | void
}
